import { getTenant, getUserName, orgSearch } from '../helpers';


export const getProgramDataAPI = async (programID, callback, programCoursesCallback)=> {
  try {
    const tenantToUse = new URLSearchParams(window.location.search).get('platform')
    const queryParam = new URLSearchParams({
      content: 'programs',
      program_id:programID,
      return_items:"True",
      tenant:tenantToUse ?? getTenant()
    });
    const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/personalized-catalog/${getUserName()}?${queryParam}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    })
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to fetch program');
    }
    const data = await response.json();
    if(!(Array.isArray(data?.results) && data.results.length > 0)){
      throw new Error('Failed to fetch program');
    }
    //const result = Array.isArray(data?.results) && data.results.length > 0   ? data?.results[0] : null
    const programData = data?.results[0]
    callback(programData)
    const programCourses =  programData?.data?.courses?.map((programCourse)=>(programCourse?.course)).filter((course)=>!!course)
    //const programCourses =  data?.results[0]?.data?.courses
    programCoursesCallback(programCourses)
  } catch (error) {
    callback(null)
    programCoursesCallback([])
  }
}

/*export const getProgramCoursesAPI = async (programID, callback)=> {
  //const data = '?program_course_listing=' + programID;
  const courseArray = [];

  try {
    const queryParam = new URLSearchParams({
      content: 'programs',
      program_id:programID,
      return_items:"True"
    });
    const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    })
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to fetch program');
    }
    const data = await response.json();
    //const result = Array.isArray(data?.results) && data.results.length > 0   ? data?.results[0] : null
    data?.results.map(async (course) => {
      const course_id = course.data.courses[0].course.course_id;
      const queryParam = new URLSearchParams({
        content: 'courses',
        course_id:course_id
      });
      const courseURL = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
      const courseResponse = await fetch(courseURL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Token ' + localStorage.getItem('dm_token'),
        },
      })

      if (!courseResponse.ok) {
        const errorData = await courseResponse.json();
        throw new Error(errorData.detail || 'Failed to fetch courses');
      }
      const data = await courseResponse.json();
      courseArray.push(data.results[0]);
      callback(courseArray);
    });
  } catch (error) {
    callback([])
  }


  /!*orgSearch(data, function (data) {
    data?.results.map((course) => {
      const course_id = course._source.course_id;
      const data =
        '?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_course"}&detail_scope={"course_id":"' +
        course_id +
        '"}';
      orgSearch(data, function (data) {
        courseArray.push(data.results[0]);
        callback(courseArray);
      });
    });
  });*!/
}*/
